module.exports = __webpack_public_path__ + "static/media/banner-1.140248fd.mp4";